// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3VRq_","buttons":"Footer_buttons__3OXBP"};